import AbstractConfig from "./AbstractConfig";

export default class Config extends AbstractConfig {
    constructor(){
        super();
    }
    
    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);
        this.setValue(Config.APPID, obj.general.appID);
        this.setValue(Config.BUILDID, obj.general.build);
        this.setValue(Config.COMMIT_HASH, obj.general.commitHash);
        this.setValue(Config.ENVIRONMENT, obj.general.environment);
    }
}

Config.APPID = "APP_ID";
Config.BUILDID = "BUILD_ID";    
Config.COMMIT_HASH = "COMMIT_HASH";
Config.ENVIRONMENT = "CFG_ENVIRONMENT";